import type * as Blockly from 'blockly/core';
import { SEG_MAP, type SegChar } from '@/(routers)/boards/editor/block/definitions/fields/fieldSevenSegStr';
import { registerHelperFunction } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const SEG_TABLE_HELPER =
    `const uint8_t segNumTable[10] = {\n` +
    `  0x3F, 0x06, 0x5B, 0x4F, 0x66,\n` +
    `  0x6D, 0x7D, 0x07, 0x7F, 0x6F\n` +
    `};\n`;

export function register(gen: any): void {
    gen.forBlock['string_seven_seg'] = function (block: Blockly.Block): [string, number] {
        const char = block.getFieldValue('CHAR') as SegChar;
        if (char === '?') {
            registerHelperFunction('segNumTable', SEG_TABLE_HELPER);
            return [`segNumTable[random(0, 10)]`, 0];
        }
        const byte = SEG_MAP[char] ?? 0x00;
        return [`0x${byte.toString(16).toUpperCase().padStart(2, '0')}`, 0];
    };
}
